module.exports = __webpack_public_path__ + "static/media/shareActive.a66ccb0c.png";